import React from 'react';

import { lazyImport } from 'services/lazy-service';

import LazyComponent from 'components/LazyComponent';

import AppLoading from 'components/app-loading';

const Main = lazyImport(() => import(/* webpackChunkName: "MainChunk"*/ 'components/main'));

const LazyMain = props => (
    <LazyComponent fallback={<AppLoading id="lazy-main" timeout={60000} />}>
        <Main {...props} />
    </LazyComponent>
);

export default React.memo(LazyMain);
